import React from 'react';
import { IconProps } from '.';

const SvgColoredPenalty = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#F05046' d='M3 3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Z' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0 1a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z'
        clipRule='evenodd'
      />
      <path fill='#fff' fillRule='evenodd' d='M14.5 12.5h-5v-1h5v1Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgColoredPenalty;
